import { Component, computed, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { ViewMenu } from '../../../models/view-menu';
import { Observable } from 'rxjs';
import { interfaceShipmentViewSelect } from '../../../store/interface/interface.actions';
import { selectShipmentsCurrentView, selectShipmentViewMenu } from '../../../store/shipments-table/shipments-table.state';
import { ShipmentTableComponent } from '../shipments-table/shipment-table.component';
import { ShipmentsTableFilterComponent } from '../shipments-table-filter/shipments-table-filter.component';
import { AsyncPipe } from '@angular/common';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { tap } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';
import { selectProfileNotices } from '../../../store/profile/profile.state';
import { NoticeTypeEnum } from '../../../enum/notice-type.enum';
import { ContextNoticesComponent } from '../../navigation/context-notices/context-notices.component';

@Component({
    selector: 'app-shipments-page',
    templateUrl: './shipments-page.component.html',
    styleUrls: ['./shipments-page.component.scss'],
    imports: [ MatTabGroup, MatTab, ShipmentsTableFilterComponent, ShipmentTableComponent, AsyncPipe, ContextNoticesComponent ]
})
export class ShipmentsPageComponent {

    constructor(private store: Store<AppState>) {
    }

    notices$ = this.store.select(selectProfileNotices([NoticeTypeEnum.QUOTE]));

    shipmentViews = this.store.selectSignal(selectShipmentViewMenu);

    selectedView = this.store.selectSignal(selectShipmentsCurrentView);

    currentViewIndex = computed(() => this.shipmentViews().findIndex(v => v.id === this.selectedView()));

    selectTab(tabIndex: number): void {
        const views = this.shipmentViews();
        if (views.length > tabIndex) {
            this.store.dispatch(interfaceShipmentViewSelect({ id: views[tabIndex].id }));
        }
    }
}
